import { render, staticRenderFns } from "./AffirmPackagePrice.vue?vue&type=template&id=097a69e0&scoped=true&"
import script from "./AffirmPackagePrice.vue?vue&type=script&lang=ts&"
export * from "./AffirmPackagePrice.vue?vue&type=script&lang=ts&"
import style0 from "./AffirmPackagePrice.vue?vue&type=style&index=0&id=097a69e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097a69e0",
  null
  
)

export default component.exports